import { qs, listen, toggle } from "@fluorescent/dom";
import { section } from "@/glow";
import SocialShare from "@/lib/social-share";

const sel = {
  toggle: "[data-js-toggle]",
  textToggle: "[data-text-toggle]",
  socialShare: ".social-share",
  passwordForm: ".password-form",
  formStatus: ".form-status",
};

section("password", {
  onLoad() {
    const toggleButton = qs(sel.toggle, this.container);
    const textToggle = qs(sel.textToggle, this.container);
    const socialShareContainer = qs(sel.socialShare, this.container);
    const passwordForm = qs(sel.passwordForm, this.container);

    this.events = [
      listen([toggleButton, textToggle], "click", e => this.toggleView(e)),
    ];

    if (socialShareContainer) {
      this.socialShare = SocialShare(socialShareContainer);
    }

    const passwordStatus = qs(sel.formStatus, passwordForm);
    if (passwordStatus) {
      this.toggleView();
    }
  },

  toggleView() {
    toggle(this.container, "welcome");
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.socialShare && this.socialShare();
  },
});
